export function getDefaults(company) {
  const { sitePreferences } = company && company.id ? company : {};
  const { isInternalMobilityEnabled } = sitePreferences || {};

  let overrides = {};

  if (this.isSainsburys) {
    overrides = { ...overrides, ...referralIntroductions };
  }

  if (isInternalMobilityEnabled) {
    overrides = { ...overrides, ...internalMobilityPlatform };
  }

  return overrides;
}

export const referralIntroductions = {
  'en:dashboard.welcome-message.recruiter-jobs-one': 'There is {current-openings-link} for employees to introduce.',
  'en:dashboard.welcome-message.recruiter-jobs-many': 'There are {current-openings-link} for employees to introduce.',
  'en:dashboard.welcome-message.employee-jobs-one': 'There is {current-openings-link} to introduce to your contacts.',
  'en:dashboard.welcome-message.employee-jobs-many': 'There are {current-openings-link} to introduce to your contacts.',
  'en:dashboard.welcome-card.title': 'It\'s easy to make introductions...',
  'en:dashboard.welcome-card.list-ol': [
    'Browse job openings',
    'Click to select one',
    'And introduce your contacts or upload their CV',
  ],
  'en:dashboard.roles-title': 'Roles to Introduce',

  'en:jobs.share-prompt.refer-by-sharing': 'Introduce this job by sharing',
  'en:jobs.ctas.item-employee': 'Introduce',

  'en:contacts.card.you-already-referred-job': 'You introduced for this role',
  'en:contacts.card.someone-already-referred-job': 'Already introduced for this role',
  'en:contacts.card.someone-already-referred-company': 'Already introduced',
  'en:contacts.card.recruiter-already-referred-requested': 'Introduction requested',
  'en:contacts.card.refer-candidate': 'Introduce',

  'en:referrals.your-referrals-title': 'Your Intros',
  'en:referrals.referral-requests-title': 'Intro Requests',
  'en:referrals.lanes.referrals-title': 'Introductions',
  'en:referrals.lanes.referrals-no-results': 'You haven\'t introduced any of your contacts yet',
  'en:referrals.errors.no-outstanding-requests': 'You have no outstanding introduction requests',
  'en:referrals.errors.no-outstanding-requests-description': 'When a recruiter requests an introduction with one of your contacts, they\'ll appear here.',

  'en:navigation.referrals': 'Introductions',
  'en:navigation.your-referrals': 'Your Intros',
  'en:navigation.referral-requests': 'Intro Requests',
};

export const internalMobilityPlatform = {
  'en:auth.register.info.title': 'Internal Mobility made simple!',
  'en:auth.register.info.content': [
    'Let the platform match you to internal opportunities that support your growth',
    'Take control of your career path by highlighting the roles and skills you want to achieve',
    'Find or become a mentor to help you and your colleagues career development',
    'Proactively improve and develop new skills taking on internal projects',
  ],
};

export const combinedPlatform = {
  'en:auth.register.info.title': 'Employee Referrals & Internal Mobility made simple!',
  'en:auth.register.info.content': [
    'Start receiving job referral recommendations automatically when your connections are matched to jobs',
    'Let the platform match you to internal opportunities that support your growth',
    'Refer your connections quickly and easily though our easy sharing features',
    'Take control of your career path by highlighting the roles and skills you want to achieve',
    'Find or become a mentor to help you and your colleagues career development',
    'Proactively improve and develop new skills taking on internal projects',
  ],
};



// WEBPACK FOOTER //
// ./src/i18n/defaults.js